import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Numeral from 'numeral';

import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';

import { URLS } from 'config';

import defaultImage from 'components/CarItem/images/default-image.jpg';

import './styles.scss';

import PickUp from './components/PickUp';
import ToMe from './components/ToMe';
import PickUpModal from './components/PickUpModal';
import containerActions from './actions';

class DeliveryPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: true,
      activeTab: 0,
      controlledDate: new Date(moment().add(1, 'day')),
      pickUpDate: this.generateDate(),
      pickUpModal: false
    };
  }

  componentWillMount() {
    this.props.getSelectedCars();
  }

  onFocusInput = () => {
    this.calendar.openDialog();
  }

  setTabHandl = activeTab => () => {
    this.setState({ activeTab });
  }

  setDateManualyHand = count => () => {
    const date = moment(this.state.controlledDate).add(count, 'days');

    this.setState({ controlledDate: new Date(date), pickUpDate: this.generateDate(date) });
  }

  generateDate = (_date = new Date(moment().add(1, 'day'))) => {
    const date = moment(_date);
    const tomorrow = moment().add(1, 'day');

    if (date.date() === moment().date()) return 'Today';

    if (date.date() === tomorrow.date()) return 'Tomorrow';

    return date.format('YYYY-MM-DD');
  }

  calendar = null;

  handleChange = (empty, controlledDate) => {
    this.setState({ controlledDate, pickUpDate: this.generateDate(controlledDate) });
  }

  pickUpModalHandl = () => {
    this.setState(prevState => ({
      pickUpModal: !prevState.pickUpModal
    }));
  }

  saveDeliveryHandl = (position, name, time) => () => {
    const delivery = {
      position,
      name,
      selfDelivery: !!this.state.activeTab
    };

    if (!this.state.activeTab) {
      const timeSplitted = moment(time, ['h:mm A']).format('HH:mm').split(':');

      const date = moment(this.state.controlledDate).set({
        hour: timeSplitted[0],
        minute: timeSplitted[1]
      });

      delivery.date = new Date(date).toString();
    }

    this.props.saveDelivery(delivery, () => {
      this.props.history.push(URLS.SIGNATURE);
    });
  }

  generateString = arr => arr.filter(el => el).join(', ');

  goBackHandl = () => {
    this.props.history.goBack();
  }

  render() {
    return (
      <Modal isOpen={this.state.isOpened}>
        <div className="page-delivery">
          <ModalHeader backHandl={this.goBackHandl}>
            Select delivery options
          </ModalHeader>

          <div className="delivery-car">
            <div className="car-wrapper">
              <div
                className="car-image"
                style={{ backgroundImage: `url(${this.props.car.images && this.props.car.images.length ? this.props.car.images[0] : defaultImage})` }}
              />
              <div className="car-info">
                <p className="info-title">
                  { this.props.car.name }
                </p>
                <p className="info-price">
                  <b>${Numeral(this.props.car.price).format('0.00') || 0}</b> monthly payment
                </p>
                <p className="info-detail">
                  { this.generateString([
                      this.props.car.base_ext_color, this.props.car.transmission
                    ])
                  }
                </p>
              </div>
            </div>
            <Link className="car-edit ion-edit" to={`/car/${this.props.car.id}`} />
          </div>

          <div className="delivery-tabs">
            <div className="tabs-header">
              {/* <button
                className={`header-item ${!this.state.activeTab ? '-active' : ''}`}
                onClick={this.setTabHandl(0)}
              >
                I like to <br /> pick up a car
              </button>
              <button
                className={`header-item ${this.state.activeTab ? '-active' : ''}`}
                onClick={this.setTabHandl(1)}
              >
                A car should be delivered to me
              </button> */}
              {/* <div
                className="header-line"
                style={{
                  left: !this.state.activeTab ? '0%' : '50%'
                }}
              /> */}
            </div>
            <div className="tabs-wrapper">
              {!this.state.activeTab ? <PickUp
                controlledDate={this.state.controlledDate}
                handleChange={this.handleChange}
                reference={(ref) => { this.calendar = ref; }}
                pickUpDate={this.state.pickUpDate}
                onFocusInput={this.onFocusInput}
                setDateManualyHand={this.setDateManualyHand}
                prevDisabled={moment().add(1, 'day').date() === moment(this.state.controlledDate).date()}
                openModal={this.pickUpModalHandl}
                saveDeliveryHandl={this.saveDeliveryHandl}
                position={{
                  lat: 43.803067,
                  lng: -79.549307
                }}
              /> : <ToMe saveDeliveryHandl={this.saveDeliveryHandl} /> }
            </div>
          </div>
        </div>
        <PickUpModal
          controlledDate={this.state.controlledDate}
          handleChange={this.handleChange}
          reference={(ref) => { this.calendar = ref; }}
          pickUpDate={this.state.pickUpDate}
          onFocusInput={this.onFocusInput}
          setDateManualyHand={this.setDateManualyHand}
          prevDisabled={moment().add(1, 'day').date() === moment(this.state.controlledDate).date()}
          isOpen={this.state.pickUpModal}
          backHandl={this.pickUpModalHandl}
          saveDeliveryHandl={this.saveDeliveryHandl}
          position={{
            lat: 43.803067,
            lng: -79.549307
          }}
        />
      </Modal>
    );
  }
}

DeliveryPage.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  getSelectedCars: PropTypes.func.isRequired,
  saveDelivery: PropTypes.func.isRequired,
  // eslint-disable-next-line
  car: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  car: state.car.car
});

export default connect(mapStateToProps, containerActions)(DeliveryPage);



// WEBPACK FOOTER //
// ./src/pages/Delivery/index.js